var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQuizInprogressIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "quiz_inprogress-icon",
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_975",
    "data-name": "Rectangle 975",
    width: 26,
    height: 26,
    fill: "none"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1844",
    "data-name": "Group 1844",
    transform: "translate(1 1)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_206",
    "data-name": "Ellipse 206",
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#afb4c5"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1843",
    "data-name": "Group 1843",
    transform: "translate(6 5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_912",
    "data-name": "Rectangle 912",
    transform: "translate(0 5)",
    fill: "none",
    stroke: "#fefefe",
    strokeWidth: 0.5
  }, /*#__PURE__*/React.createElement("rect", {
    width: 4,
    height: 4,
    rx: 0.4,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 0.25,
    width: 3.5,
    height: 3.5,
    rx: 0.15,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_914",
    "data-name": "Rectangle 914",
    transform: "translate(0 10)",
    fill: "none",
    stroke: "#fefefe",
    strokeWidth: 0.5
  }, /*#__PURE__*/React.createElement("rect", {
    width: 4,
    height: 4,
    rx: 0.4,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 0.25,
    width: 3.5,
    height: 3.5,
    rx: 0.15,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_911",
    "data-name": "Rectangle 911",
    transform: "translate(6 1)",
    fill: "#fefefe",
    stroke: "#fefefe",
    strokeWidth: 0.5
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 2,
    rx: 0.3,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 0.25,
    width: 5.5,
    height: 1.5,
    rx: 0.05,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_913",
    "data-name": "Rectangle 913",
    transform: "translate(6 6)",
    fill: "#fefefe",
    stroke: "#fefefe",
    strokeWidth: 0.5
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 2,
    rx: 0.3,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 0.25,
    width: 5.5,
    height: 1.5,
    rx: 0.05,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_915",
    "data-name": "Rectangle 915",
    transform: "translate(6 11)",
    fill: "#fefefe",
    stroke: "#fefefe",
    strokeWidth: 0.5
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 2,
    rx: 0.3,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 0.25,
    width: 5.5,
    height: 1.5,
    rx: 0.05,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1842",
    "data-name": "Group 1842"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_907",
    "data-name": "Rectangle 907",
    fill: "none",
    stroke: "#fefefe",
    strokeWidth: 0.5
  }, /*#__PURE__*/React.createElement("rect", {
    width: 4,
    height: 4,
    rx: 0.4,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 0.25,
    width: 3.5,
    height: 3.5,
    rx: 0.15,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Icon_feather-check",
    "data-name": "Icon feather-check",
    d: "M7.75,9l-1.2,1.458L6,9.8",
    transform: "translate(-4.75 -7.729)",
    fill: "none",
    stroke: "#fefefe",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.5
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuizInprogressIcon);
export default __webpack_public_path__ + "static/media/quiz_inprogress_icon.6f08c3543c6759c9361dc62e40a33aae.svg";
export { ForwardRef as ReactComponent };